import type {TFunction} from "i18next";
import {getFeatureFlagLabel} from "./featureFlags";

const LABEL_KEYS: Record<string, string> = {
    smsSending: "FEATURE_SMS_SENDING",
    onlineBooking: "FEATURE_ONLINE_BOOKING",
    themePicker: "FEATURE_THEME_PICKER",
    fileUpload: "FEATURE_FILE_UPLOAD",
    precalculatedAvailabilities: "FEATURE_PRECALCULATED_AVAILABILITIES",
    firstLaunch: "FEATURE_FIRST_LAUNCH",
    shiftSchedule: "FEATURE_SHIFT_SCHEDULE",
    smartBooking: "FEATURE_SMART_BOOKING",
    resourceManagement: "FEATURE_RESOURCE_MANAGEMENT",
    supportAssistant: "FEATURE_SUPPORT_ASSISTANT",
    stripePayments: "FEATURE_STRIPE_PAYMENTS",
    bulkSms: "FEATURE_BULK_SMS",
    subscriptionTesting: "FEATURE_SUBSCRIPTION_TESTING",
    appointmentsV2: "FEATURE_APPOINTMENTS_V2",
    testDataGenerator: "FEATURE_TEST_DATA_GENERATOR",
    strictTimeSlots: "FEATURE_STRICT_TIME_SLOTS",
    smsSenderRegistration: "FEATURE_SMS_SENDER_REGISTRATION",
    appointmentChangeHistory: "FEATURE_APPOINTMENT_CHANGE_HISTORY",
    material3: "FEATURE_MATERIAL_3",
    publicRouterCaptcha: "FEATURE_PUBLIC_ROUTER_CAPTCHA",
    smsProvider: "FEATURE_SMS_PROVIDER",
};

/** Translated name of a feature flag; flags added later fall back to their split camel-case key. */
export function featureFlagLabel(t: TFunction, flag: string): string {
    const key = LABEL_KEYS[flag];
    return key ? t(key) : getFeatureFlagLabel(flag);
}
